import axios from 'axios';
import humps from 'humps';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  transformRequest: (data) => JSON.stringify(humps.decamelizeKeys(data)),
  transformResponse: (data) => {
    try {
      const parsedData = JSON.parse(data);

      return humps.camelizeKeys(parsedData);
    } catch {
      return data;
    }
  },
});

export function attachToken(token) {
  instance.defaults.headers.common['x-token'] = token;
}

export async function checkToken(token) {
  try {
    const { data } = await instance.get('/api/user/detail', {
      headers: { 'x-token': token },
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function createCustomer(body) {
  try {
    const { data } = await instance.post('/api/customer', body);

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function createOperator(body) {
  try {
    const { data } = await instance.post('/api/admin/user/create', body);

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function createProduct(body) {
  try {
    const { data } = await instance.post('/api/product', body);

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function createSku(body) {
  try {
    const { data } = await instance.post('/api/sku', body);

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function deleteOperator(body) {
  try {
    const { data } = await instance.delete('/api/admin/user/delete', {
      data: body,
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function downloadReport(id) {
  try {
    const { data } = await instance.get(`/api/report/${id}`, {
      responseType: 'blob',
    });

    return data;
  } catch (e) {
    throw e;
  }
}

export async function fetchListCustomer(params) {
  try {
    const { data } = await instance.get('/api/customer/list', {
      params: humps.decamelizeKeys(params),
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function fetchListOperator(params) {
  try {
    const { data } = await instance.get('/api/admin/user/list', {
      params: humps.decamelizeKeys(params),
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function fetchListProduct(params) {
  try {
    const { data } = await instance.get('/api/product/list', {
      params: humps.decamelizeKeys(params),
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function fetchListReport(params) {
  try {
    const { data } = await instance.get('/api/report/list', {
      params: humps.decamelizeKeys(params),
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function fetchListSku(params) {
  try {
    const { data } = await instance.get('/api/sku/list', {
      params: humps.decamelizeKeys(params),
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function fetchListSkuProducts(skuId, params) {
  try {
    const { data } = await instance.get(`/api/sku/${skuId}/product/list`, {
      params: humps.decamelizeKeys(params),
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function fetchProductDetail(productId) {
  try {
    const { data } = await instance.get(`/api/serial_number/${productId}`);

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function fetchTrackingInfo(params) {
  try {
    const { data } = await instance.get(`/api/tracking/${params.id}`, {
      params: humps.decamelizeKeys(params),
    });

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function logIn(body) {
  try {
    const { headers, data } = await instance.post('/api/user/login', body);

    return { token: headers['x-token'], ...data.data };
  } catch (e) {
    throw e;
  }
}

export async function updateCustomer(body) {
  try {
    const { data } = await instance.put(
      `/api/customer/${body.customerId}`,
      body
    );

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function updateProduct(body) {
  try {
    const { data } = await instance.put(`/api/product/${body.productId}`, body);

    return data.data;
  } catch (e) {
    throw e;
  }
}

export async function updateSku(body) {
  try {
    const { data } = await instance.put(`/api/sku/${body.id}`, body);

    return data.data;
  } catch (e) {
    throw e;
  }
}
